import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, lang, ...props }, ref) => {
  // Force la locale française (24h, sans AM/PM) sur les champs date/heure.
  // Sans cela, Chrome se base sur la locale OS de l'utilisateur et peut afficher
  // "09:00 AM / 05:00 PM" au lieu de "09:00 / 17:00".
  const isDateTimeType = type === "time" || type === "date" || type === "datetime-local";
  const resolvedLang = lang || (isDateTimeType ? "fr-FR" : undefined);
  return (
    <input
      type={type}
      lang={resolvedLang}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
